import { createAction, props } from '@ngrx/store';

export namespace BackendStorageActions {
  export const GetKeyValue = createAction(
    '[SETTINGS] Get Key Value',
    props<{
      key: string;
    }>()
  );

  export const GetKeyValueWithoutPropagation = createAction(
    '[SETTINGS] Get Key Value Without Propagation',
    props<{
      key: string;
    }>()
  );

  export const GetKeyValueSuccess = createAction(
    '[SETTINGS] Get Key Value Success',
    props<{
      key: string;
      value: any;
    }>()
  );

  export const GetKeyValueWithoutPropagationSuccess = createAction(
    '[SETTINGS] Get Key Value Without Propagation Success',
    props<{
      key: string;
      value: any;
    }>()
  );

  export const GetKeyValueError = createAction('[SETTINGS] Get Key Value Error');

  export const SetKeyValue = createAction(
    '[SETTINGS] Set Key Value',
    props<{
      key: string;
      value: any;
      gatewaySerial?: string;
    }>()
  );

  export const SetKeyValueSuccess = createAction(
    '[SETTINGS] Set Key Value Success',
    props<{
      key: string;
      value: any;
    }>()
  );

  export const SetKeyValueError = createAction(
    '[SETTINGS] Set Key Value Error',
    props<{
      gatewaySerial?: string;
    }>()
  );
}
